/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalServiceGroupInfoRespVo } from './AdditionalServiceGroupInfoRespVo';
import {
    AdditionalServiceGroupInfoRespVoFromJSON,
    AdditionalServiceGroupInfoRespVoFromJSONTyped,
    AdditionalServiceGroupInfoRespVoToJSON,
    AdditionalServiceGroupInfoRespVoToJSONTyped,
} from './AdditionalServiceGroupInfoRespVo';

/**
 * 
 * @export
 * @interface PageDataAdditionalServiceGroupInfoRespVo
 */
export interface PageDataAdditionalServiceGroupInfoRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataAdditionalServiceGroupInfoRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataAdditionalServiceGroupInfoRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataAdditionalServiceGroupInfoRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<AdditionalServiceGroupInfoRespVo>}
     * @memberof PageDataAdditionalServiceGroupInfoRespVo
     */
    records?: Array<AdditionalServiceGroupInfoRespVo>;
}

/**
 * Check if a given object implements the PageDataAdditionalServiceGroupInfoRespVo interface.
 */
export function instanceOfPageDataAdditionalServiceGroupInfoRespVo(value: object): value is PageDataAdditionalServiceGroupInfoRespVo {
    return true;
}

export function PageDataAdditionalServiceGroupInfoRespVoFromJSON(json: any): PageDataAdditionalServiceGroupInfoRespVo {
    return PageDataAdditionalServiceGroupInfoRespVoFromJSONTyped(json, false);
}

export function PageDataAdditionalServiceGroupInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataAdditionalServiceGroupInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(AdditionalServiceGroupInfoRespVoFromJSON)),
    };
}

export function PageDataAdditionalServiceGroupInfoRespVoToJSON(json: any): PageDataAdditionalServiceGroupInfoRespVo {
    return PageDataAdditionalServiceGroupInfoRespVoToJSONTyped(json, false);
}

export function PageDataAdditionalServiceGroupInfoRespVoToJSONTyped(value?: PageDataAdditionalServiceGroupInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(AdditionalServiceGroupInfoRespVoToJSON)),
    };
}

